<template>
	<div class="container-fluid">
		<div class="card">
      <div class="card-header">
        <h2 class="card-title">{{ entrada.titulo}}</h2>
      </div>
      <div class="card-creador">Publicado por: {{ entrada.creador }}</div>
      <div class="card-body" v-html="entrada.contenido">
      </div>
      <div class="card-footer text-right">
      	<button class="btn btn-secondary mr-2" @click="$router.go(-1)">Regresar...</button>
      	<a class="btn btn-dark" :href="entrada.permalink" target="_blank">Visitar url original...</a>
      </div>
    </div>
	</div>
</template>

<script type="text/javascript">
	import api from '@/api/clientes'

	export default {
		data: function() {
			return {
				entrada: {
					titulo: null
					,contenido: null
					,publicacion_at: null
				}
			}
		}
		,mounted: function() {
			this.obtener_entrada();
		}
		,methods: {
			obtener_entrada: async function() {
				try {
					this.entrada = (await api.obtener_blog_entrada(this.$route.params.id)).data;

					this.actualizar_leidas();
				}catch(e) {
					this.$log.info('Err', e);
                	this.$swal('Error','Error al descargar las facturas: '+e.message,'error');
				}
			}
			,actualizar_leidas: async function() {
				try {
					let noLeidas = (await api.obtener_blog_noleidas()).data;
		          	this.$store.commit('setNoLeidas', noLeidas);
		        }catch(e) {
		          	this.$log.info('Err', e);
		          	this.$swal('Error','Error al descargar las facturas: '+e.message,'error');
		        }
			}
		}
	}
</script>

<style lang="scss">
	.card-creador {
		font-size: 0.9em;
		font-weight: bold;
		color: #999999;
		text-align: right;
		padding: 1.3rem 1.60rem 0.3rem 1.60rem;
	}
</style>